export default "__VITE_ASSET__CMgRLtVh__"